
define(
	'Code25.CaterpartsGlobal.Tracking'
	, [
		"Utils", "Handlebars", "Backbone.CollectionView"
	]
	, function (
		Utils, Handlebars, BackboneCollectionView
	) {
		'use strict';
		return {
			mount: function mount(container) {

				var TrackingView = require("OrderHistory.List.Tracking.Number.View");
				if (TrackingView) {
					if (TrackingView.TrackingView) {
						TrackingView = TrackingView.TrackingView;
					}
					_.extend(TrackingView.prototype, {


						getContext: _.wrap(TrackingView.prototype.getContext, function (getContext) {

							var res = getContext.apply(this, _.rest(arguments));
							var columns = this.model.get("columns"), value;
							if (columns) {
								res.firstTrackingNumberURL = "";
								for (var i = 0; i < columns.length; i++) {

									if (columns[i].name == "custbody_sales_tracking_data") {
										value = columns[i].value;
										if (value) {
											columns[i].value = "";
											value = JSON.parse(value);

											for (var j in value) {

												if (value[j].trkNumber) {
													res.firstTrackingNumberName = null;
													res.firstTrackingNumberText = value[j].trkNumber;
													res.firstTrackingNumberURL = value[j].trkLink;
													res.isTrackingNumberCollectionEmpty = false;
													res.isTrackingNumberCollectionLengthEqual1 = true;
													res.trackingNumbers = [
														{ serviceName: null, serviceURL: value[j].trkLink, trackingNumber: value[j].trkNumber }
													];
													res.trackingNumbersLength = 1;
													break;
												}
											}


										}
									}
								}
							}
							return res;

						})
					});
				}

				var RecordViewsView = require("RecordViews.View");
				if (RecordViewsView.RecordViewsView) {
					RecordViewsView = RecordViewsView.RecordViewsView;
				}
				var OverviewHomeView = require('Overview.Home.View');
				if (OverviewHomeView) {

					_.extend(OverviewHomeView.prototype.childViews, {
						'Order.History.Results': _.wrap(OverviewHomeView.prototype.childViews['Order.History.Results'], function (getView) {

							var self = this;
							var records_collection = new Backbone.Collection(
								this.collection.map(function (order) {
									var dynamic_column;

									if (self.isSCISIntegrationEnabled) {
										dynamic_column = {
											label: Utils.translate('Origin:'),
											type: 'origin',
											name: 'origin',
											value: (_.findWhere(
												Configuration.get('transactionRecordOriginMapping'),
												{
													origin: order.get('origin')
												}
											)).name
										};
									} else {
										dynamic_column = {
											label: Utils.translate('Status:'),
											type: 'status',
											name: 'status',
											value: order.get('status').name
										};
									}
									var firstTrackingNumberText, firstTrackingNumberURL;
									var custbody_sales_tracking_data = order.get('custbody_sales_tracking_data');
									if (custbody_sales_tracking_data) {
										
										custbody_sales_tracking_data=custbody_sales_tracking_data.split("\r").join(" ");
										custbody_sales_tracking_data=custbody_sales_tracking_data.split("\n").join(" ");
										
										var value = JSON.parse(custbody_sales_tracking_data);

										for (var j in value) {

											if (value[j].trkNumber) {

												firstTrackingNumberText = value[j].trkNumber;
												firstTrackingNumberURL = value[j].trkLink;
												break;
											}
										}
									}


									var columns = [
										{
											label: Utils.translate('Date:'),
											type: 'date',
											name: 'date',
											value: order.get('trandate')
										},
										{
											label: Utils.translate('Amount:'),
											type: 'currency',
											name: 'amount',
											value: order.get('amount_formatted')
										}, {
											label: "Track items",
											type: 'tracking-number',
											name: 'trackingNumber2',
											value: firstTrackingNumberText || order.get('trackingnumbers'),
											firstTrackingNumberURL: firstTrackingNumberURL
										}
									];

									columns.splice(2, 0, dynamic_column);

									var model = new Backbone.Model({
										title: new Handlebars.SafeString(
											Utils.translate('<span class="tranid">$(0)</span>', order.get('tranid'))
										),
										touchpoint: 'customercenter',
										detailsURL: '/purchases/view/'+order.get('recordtype')+'/'+order.get('internalid'),
										recordType: order.get('recordtype'),
										id: order.get('internalid'),
										internalid: order.get('internalid'),
										trackingNumbers: order.get('trackingnumbers'),
										columns: columns
									});

									return model;
								})
							);

							return new BackboneCollectionView({
								childView: RecordViewsView,
								collection: records_collection,
								viewsPerRow: 1
							});

						})
					});
				}

				// var RecordViewsView=require("RecordViews.View");
				// 		if(RecordViewsView.RecordViewsView){
				// 			RecordViewsView=RecordViewsView.RecordViewsView;
				// 		}

				var OrderHistoryPackagesView = require('OrderHistory.Packages.View');
				if (OrderHistoryPackagesView) {
					if (OrderHistoryPackagesView.OrderHistoryPackagesView) {
						OrderHistoryPackagesView = OrderHistoryPackagesView.OrderHistoryPackagesView;
					}
					_.extend(OrderHistoryPackagesView.prototype, {


						getContext: _.wrap(OrderHistoryPackagesView.prototype.getContext, function (getContext) {
							var res = getContext.apply(this, _.rest(arguments));

							var model = this.parentView && this.parentView.parentView && this.parentView.parentView.model;
							if (model) {

								var options = model.get("options");

								if (options && options.custbody_sales_tracking_data) {

									options.custbody_sales_tracking_data=options.custbody_sales_tracking_data.split("\r").join(" ");
										options.custbody_sales_tracking_data=options.custbody_sales_tracking_data.split("\n").join(" ");
										

									var value = JSON.parse(options.custbody_sales_tracking_data);

									for (var j in value) {

										if (value[j].trkNumber) {

											res.firstTrackingNumberText = value[j].trkNumber;
											res.firstTrackingNumberURL = value[j].trkLink;
											break;
										}
									}

								}
							}

							return res;

						})
					});
				}

			}

		}

	});
